import SelectAllMatchingBanner from '@/components/table/SelectAllMatchingBanner';
import useAffiliateBulkEmailStore from '@/stores/affiliate-bulk-email-store';
import { useTranslation } from 'react-i18next';

interface AffiliateSelectAllBannerProps {
  /** Ids of the affiliates on the current page. */
  pageIds: string[];
  /** Total affiliates matching the current filter. */
  matchingTotal: number;
}

/**
 * Affiliate-specific container around the generic SelectAllMatchingBanner: wires
 * the affiliate bulk-email selection store and the localized copy.
 */
const AffiliateSelectAllBanner: React.FC<AffiliateSelectAllBannerProps> = ({
  pageIds,
  matchingTotal,
}) => {
  const { t } = useTranslation();
  const selectedIds = useAffiliateBulkEmailStore((s) => s.selectedIds);
  const selectAllMatching = useAffiliateBulkEmailStore((s) => s.selectAllMatching);
  const enableSelectAllMatching = useAffiliateBulkEmailStore((s) => s.enableSelectAllMatching);
  const clearSelection = useAffiliateBulkEmailStore((s) => s.clearSelection);

  const allPageSelected = pageIds.length > 0 && pageIds.every((id) => selectedIds.has(id));

  return (
    <SelectAllMatchingBanner
      allPageSelected={allPageSelected}
      selectAllMatching={selectAllMatching}
      pageCount={pageIds.length}
      matchingTotal={matchingTotal}
      onSelectAllMatching={() => enableSelectAllMatching(matchingTotal)}
      onClear={clearSelection}
      labels={{
        pageSelected: t('affiliates.selectAll.pageSelected', { count: pageIds.length }),
        selectMatching: t('affiliates.selectAll.selectMatching', { count: matchingTotal }),
        allMatchingSelected: t('affiliates.selectAll.allMatchingSelected', {
          count: matchingTotal,
        }),
        clear: t('affiliates.selectAll.clear'),
      }}
    />
  );
};

export default AffiliateSelectAllBanner;
